import { Shop } from "../../shops/domain/Shop";
import { Product } from "./Product";

export abstract class ProductRepository {
    abstract imageOfProduct(shop: Shop, id: string): Promise<any>;
    abstract getRawProducts(): Promise<Product[]>;
    abstract ofShop(shop: Shop): Promise<Product[]>;
}